export default __webpack_public_path__ + "static/media/mt5-logo.72efad17.png";